import clsx from 'clsx'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { IconSvg } from '../../../icons'

export const TagAutonomousBooking = ({ className }: { className?: string }) => {
  return (
    <div className={clsx(s.badge, className)}>
      <IconSvg.Flash />
      <FormattedMessage
        id='ui.TagAutonomousBooking.autonomousTag'
        defaultMessage='Réservation instantanée'
      />
    </div>
  )
}
